// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/
.modal-Notification {
  pointer-events: all;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: row;
  -webkit-justify-content: center;
  justify-content: center;
  clear: both;
  box-sizing: border-box;
  position: relative;
  min-width: 200px;
  max-width: min(66vw, 800px);
  background-color: var(--theia-editorWidget-background);
  min-height: 35px;
  margin-bottom: 1px;
  color: var(--theia-editorWidget-foreground);
}

.modal-Notification .icon {
  display: inline-block;
  font-size: 20px;
  padding: 5px 0;
  width: 35px;
  order: 1;
}

.modal-Notification .icon .codicon {
  line-height: inherit;
  vertical-align: middle;
  font-size: calc(var(--theia-ui-padding) * 5);
  color: var(--theia-editorInfo-foreground);
}

.modal-Notification .icon .error {
  color: var(--theia-editorError-foreground);
}

.modal-Notification .icon .warning {
  color: var(--theia-editorWarning-foreground);
}

.modal-Notification .text {
  order: 2;
  display: inline-block;
  max-height: min(66vh, 600px);
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  align-self: center;
  flex: 1 100%;
  padding: 10px;
  overflow: auto;
  white-space: pre-wrap;
}

.modal-Notification .text > p {
  margin: 0;
  font-size: var(--theia-ui-font-size1);
  font-family: var(--theia-ui-font-family);
  vertical-align: middle;
}

.modal-Notification .buttons {
  display: flex;
  flex-direction: row;
  order: 3;
  white-space: nowrap;
  align-self: flex-end;
  height: 40px;
}

.modal-Notification .buttons > button {
  background-color: var(--theia-button-background);
  color: var(--theia-button-foreground);
  border: none;
  border-radius: 0;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  padding: 0 10px;
  margin: 0;
  font-size: var(--theia-ui-font-size1);
  outline: none;
  cursor: pointer;
}

.modal-Notification .buttons > button:hover {
  background-color: var(--theia-button-hoverBackground);
}

.modal-Notification .detail {
  align-self: center;
  order: 3;
  flex: 1 100%;
  color: var(--theia-descriptionForeground);
}

.modal-Notification .detail > p {
  margin: calc(var(--theia-ui-padding) * 2) 0px 0px 0px;
}

.modal-Notification .text {
  padding: calc(var(--theia-ui-padding) * 1.5);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/plugin-ext/src/main/browser/dialogs/style/modal-notification.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;AACjF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,sDAAsD;EACtD,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,QAAQ;EACR,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n.modal-Notification {\n  pointer-events: all;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: flex;\n  flex-direction: row;\n  -webkit-justify-content: center;\n  justify-content: center;\n  clear: both;\n  box-sizing: border-box;\n  position: relative;\n  min-width: 200px;\n  max-width: min(66vw, 800px);\n  background-color: var(--theia-editorWidget-background);\n  min-height: 35px;\n  margin-bottom: 1px;\n  color: var(--theia-editorWidget-foreground);\n}\n\n.modal-Notification .icon {\n  display: inline-block;\n  font-size: 20px;\n  padding: 5px 0;\n  width: 35px;\n  order: 1;\n}\n\n.modal-Notification .icon .codicon {\n  line-height: inherit;\n  vertical-align: middle;\n  font-size: calc(var(--theia-ui-padding) * 5);\n  color: var(--theia-editorInfo-foreground);\n}\n\n.modal-Notification .icon .error {\n  color: var(--theia-editorError-foreground);\n}\n\n.modal-Notification .icon .warning {\n  color: var(--theia-editorWarning-foreground);\n}\n\n.modal-Notification .text {\n  order: 2;\n  display: inline-block;\n  max-height: min(66vh, 600px);\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  align-self: center;\n  flex: 1 100%;\n  padding: 10px;\n  overflow: auto;\n  white-space: pre-wrap;\n}\n\n.modal-Notification .text > p {\n  margin: 0;\n  font-size: var(--theia-ui-font-size1);\n  font-family: var(--theia-ui-font-family);\n  vertical-align: middle;\n}\n\n.modal-Notification .buttons {\n  display: flex;\n  flex-direction: row;\n  order: 3;\n  white-space: nowrap;\n  align-self: flex-end;\n  height: 40px;\n}\n\n.modal-Notification .buttons > button {\n  background-color: var(--theia-button-background);\n  color: var(--theia-button-foreground);\n  border: none;\n  border-radius: 0;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  padding: 0 10px;\n  margin: 0;\n  font-size: var(--theia-ui-font-size1);\n  outline: none;\n  cursor: pointer;\n}\n\n.modal-Notification .buttons > button:hover {\n  background-color: var(--theia-button-hoverBackground);\n}\n\n.modal-Notification .detail {\n  align-self: center;\n  order: 3;\n  flex: 1 100%;\n  color: var(--theia-descriptionForeground);\n}\n\n.modal-Notification .detail > p {\n  margin: calc(var(--theia-ui-padding) * 2) 0px 0px 0px;\n}\n\n.modal-Notification .text {\n  padding: calc(var(--theia-ui-padding) * 1.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
